// components/SelectLabeled.tsx
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MenuItem, TextFieldProps } from "@mui/material";
import React from "react";
import { BlockContainer } from "../../../styles/BlockContainer";
import TextFieldLabeled from "../TextFieldLabeled";

export interface SelectLabeledProps
  extends Omit<TextFieldProps, "label" | "select"> {
  label: React.ReactNode;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: { value: string; label: React.ReactNode }[];
}

/**
 * exactly the same chrome as TextFieldLabeled, but in “select” mode
 */
const SelectLabeled: React.FC<SelectLabeledProps> = ({
  label,
  options,
  value,
  onChange,
  name,
  InputProps = {},
  ...rest
}) => {
  return (
    <BlockContainer>
      <TextFieldLabeled
        select
        fullWidth
        label={label}
        value={value}
        onChange={onChange}
        name={name}
        InputProps={{
          disableUnderline: true,
          sx: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            padding: "10px",
            height: "36px",
            bgcolor: "hsl(var(--background))",
            color: "hsl(var(--foreground))",
          },
          ...InputProps,
          // replace the default arrow with the same caret you want:
          endAdornment: (
            <ExpandMoreIcon
              fontSize="small"
              sx={{ color: "hsl(var(--muted-foreground))", mr: -1 }}
            />
          ),
        }}
        SelectProps={{
          // remove default icon so we can use our own in endAdornment
          IconComponent: () => null,
          MenuProps: {
            disableScrollLock: true, // Empêche la modification du body
          },
        }}
        sx={{
          "& .MuiInputBase-input": {
            fontSize: "14px",
            paddingY: "4px",
            color: "hsl(var(--foreground))",
            "&::placeholder": {
              color: "hsl(var(--muted-foreground))",
              opacity: 1,
              fontSize: "14px",
            },
          },
          "& .MuiInputBase-root:focus-within": {
            borderColor: "hsl(var(--primary))",
            borderWidth: "2px",
          },
          "& .MuiMenuItem-root": {
            color: "hsl(var(--foreground))",
            bgcolor: "hsl(var(--background))",
            "&:hover": {
              bgcolor: "hsl(var(--muted))",
            },
          },
        }}
        {...rest}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextFieldLabeled>
    </BlockContainer>
  );
};

export default SelectLabeled;
